import { render, staticRenderFns } from "./TheEditor.vue?vue&type=template&id=179acaa2&scoped=true"
import script from "./TheEditor.vue?vue&type=script&lang=js"
export * from "./TheEditor.vue?vue&type=script&lang=js"
import style0 from "./TheEditor.vue?vue&type=style&index=0&id=179acaa2&prod&scoped=true&lang=scss"
import style1 from "./TheEditor.vue?vue&type=style&index=1&id=179acaa2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179acaa2",
  null
  
)

export default component.exports